module.exports = __webpack_public_path__ + "img/step8.9b2db016.jpg";